<template>
  <div id="couponPlanList">
    <div class="table-container">
      <div class="table-filtrate">
        <ul>
          <li>
            <span class="label">输入关键字:</span>
            <el-input
              placeholder="请输入内容"
              v-model="filtrate.keyword"
              @keyup.enter.native="getList(1)"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getList(1)"
              ></el-button>
            </el-input>
          </li>
          <li>
            <span class="label">优惠券类型:</span>
            <el-select
              v-model="filtrate.couponType"
              placeholder="请选择优惠券类型"
              clearable
              @change="getList(1)"
            >
              <el-option label="按时间" value="按时间"> </el-option>
              <el-option label="按金额" value="按金额"> </el-option>
              <el-option label="单次免费" value="单次免费"> </el-option>
            </el-select>
          </li>
          <li>
            <el-button class="resetBtn" size="medium" @click="reset"
              >重置
            </el-button>
          </li>
        </ul>
        <ul>
          <li>
            <el-button
              class="addCoupon"
              type="primary"
              @click="$refs.editCouponDialog.show = true"
              v-if="
                buttonList.includes(
                  'parkingLotList-detail-merchantTab-detail-couponPlanList_Tab-add'
                )
              "
              ><i class="iconfont icon-jiahao"></i> 新增发券计划
            </el-button>
          </li>
        </ul>
      </div>
      <el-table
        :data="table.tableData"
        style="width: 100%"
        v-loading="table.loading"
      >
        <el-table-column prop="couponName" label="优惠券名称" align="center">
        </el-table-column>
        <el-table-column prop="couponType" label="优惠券类型" align="center">
        </el-table-column>
        <el-table-column prop="couponValue" label="优惠券金额" align="center">
        </el-table-column>
        <el-table-column prop="maxIssue" label="最多可领" align="center">
        </el-table-column>
        <el-table-column prop="releaseNum" label="发放数量" align="center">
        </el-table-column>
        <el-table-column prop="releaseType" label="发放频率" align="center">
        </el-table-column>
        <el-table-column prop="renewable" label="周期清零" align="center">
        </el-table-column>
        <el-table-column prop="expireDays" label="过期天数" align="center">
        </el-table-column>
        <el-table-column prop="createAt" label="创建时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="planCurrent(scope.row.planId)"
              v-if="scope.row.firstMonthIssued === '否'"
              >立即发放
            </el-button>
            <el-button
              type="text"
              @click="edit(scope.row)"
              v-if="
                buttonList.includes(
                  'parkingLotList-detail-merchantTab-detail-couponPlanList_Tab-edit'
                )
              "
              >编辑
            </el-button>
            <el-button
              type="text"
              @click="del(scope.row.planId)"
              v-if="
                buttonList.includes(
                  'parkingLotList-detail-merchantTab-detail-couponPlanList_Tab-delete'
                )
              "
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          layout="sizes, prev, pager, next,jumper"
          background
          :total="table.total"
          :page-size.sync="table.pageSize"
          :current-page.sync="table.page"
          @size-change="getList(1)"
          @current-change="getList"
        >
        </el-pagination>
      </div>
    </div>
    <edit-coupon-dialog ref="editCouponDialog" :getList="getList" />
  </div>
</template>
<script>
export default {
  components: {
    editCouponDialog: () => import("./editCouponDialog.vue"),
  },
  data() {
    return {
      filtrate: {
        keyword: "",
        couponType: "",
      },

      table: {
        tableData: [],
        total: 0,
        page: 1,
        pageSize: 10,
        loading: false,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    edit(row) {
      this.$refs.editCouponDialog.planId = row.planId;
      this.$refs.editCouponDialog.addForm = {
        couponName: row.couponName,
        couponType: row.couponType,
        couponValue: row.couponValue,
        expireDays: row.expireDays,
        availNum: row.availNum,
        maxIssue: row.maxIssue,
        isDefault: row.isDefault,
        couponHours: row.couponHours,
        releaseNum: row.releaseNum,
        releaseType: row.releaseType,
        renewable: row.renewable,
      };
      this.$refs.editCouponDialog.show = true;
    },
    del(planId) {
      this.$confirm("此操作将永久删除该优惠券, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await this.$http.delete(`/coupon/plan/delete/${planId}`);
          if (res.code === 0) {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    reset() {
      this.filtrate = {
        keyword: "",
        couponType: "",
      };
      this.getList(1);
    },
    planCurrent(planId) {
      this.$confirm("此操作将立即发放该优惠券, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await this.$http.post(
            `/coupon/plan/issue/current/${planId}`
          );
          if (res.code === 0) {
            this.$message.success("操作成功");
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    async getList(page = this.table.page) {
      this.table.page = page;
      try {
        this.table.loading = true;
        let res = await this.$http.post("/coupon/plan/list", {
          merchantId: this.$route.params.id,
          pageNum: page,
          pageSize: this.table.pageSize,
          keyword: this.filtrate.keyword,
          couponType: this.filtrate.couponType
            ? this.filtrate.couponType
            : null,
        });
        if (res.code === 0) {
          for (let item of res.data.list) {
            item.createAt = this.$moment(item.createAt).format(
              "yyyy-MM-DD HH:mm:ss"
            );
          }
          this.table.tableData = res.data.list;
          this.table.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {
        this.$message.error(err);
      } finally {
        this.table.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
#couponPlanList {
  .table-container {
    .table-filtrate {
      ul {
        li {
          .addCoupon {
            background-color: #ff9747;
            border-color: #ff9747;

            i {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
